import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProblemReframe } from '../components/ProblemReframe';
import { ProtocolTable } from '../components/ProtocolTable';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { Results } from '../components/Results';
import { WhoItsFor } from '../components/WhoItsFor';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden selection:bg-[#0d9488] selection:text-white" data-id="element-244">
      <Hero data-id="element-245" />
      <PainPoints data-id="element-246" />
      <ProblemReframe data-id="element-247" />
      <ProtocolTable data-id="element-248" />
      <WhatsIncluded data-id="element-249" />
      <Results data-id="element-250" />
      <WhoItsFor data-id="element-251" />
      <FinalCTA data-id="element-252" />
      <Footer data-id="element-253" />
    </main>;
}